import { Button, FormElement, RadioBox } from "@/components";
import { usePostCouponCheck } from "@/shared/server";
import { Box, Flex, Input, Select, Text, useToast } from "@chakra-ui/react";
import { PAID_MODE_GROUP, usePaymentRoomState } from "@shared/client";
import { useEffect, useRef, useState } from "react";
import { Controller, useFormContext, useWatch } from "react-hook-form";
import { CustomInputTitle, CustomTitle } from "./payerInfo.style";
import { PayerInfoProps } from "./payerInfo.type";

export const PayerInfo = ({ control, account, use, onlyUseAccount }: PayerInfoProps) => {
    const { setValue } = useFormContext();
    const payMethod = useWatch({ control, name: "payMethod" });
    const toast = useToast();
    const [couponApply, setCouponApply] = useState(false);
    const inputRef = useRef<HTMLInputElement>(null);
    const { mutate } = usePostCouponCheck();
    const [paymentRoom, setPaymentRoom] = usePaymentRoomState();

    const edate = paymentRoom[0]?.date
        .split("~")[1]
        .trim()
        .replace(/\(.*?\)/, "");

    const updatedPaymentModes =
        onlyUseAccount === "true"
            ? PAID_MODE_GROUP.filter((mode) => mode.name === "account")
            : use === "true"
              ? PAID_MODE_GROUP
              : PAID_MODE_GROUP.filter((mode) => mode.name !== "account");
    const handleCouponCheck = () => {
        const coupon = inputRef.current?.value?.trim() || "";
        if (!coupon) {
            toast({
                duration: 3000,
                position: "top",
                description: "쿠폰을 입력해주세요.",
                title: "쿠폰적용실패",
                status: "error",
            });
        }
        if (coupon) {
            mutate(
                { edate: edate, coupon_name: coupon },
                {
                    onSuccess: (res) => {
                        if (res === "failed") {
                            toast({
                                duration: 3000,
                                position: "top",
                                description: "쿠폰코드 및 적용 가능한 투숙일정을 확인해주세요.",
                                title: "쿠폰 적용 실패",
                                status: "error",
                            });
                        }
                        if (typeof res === "object" && res !== null) {
                            const discountValue = res.discount;

                            if (res.discount_name === "percent") {
                                setPaymentRoom((prev) =>
                                    prev.map((item) => ({
                                        ...item,
                                        couponDiscount: (item.discountPrice * discountValue) / 100,
                                    })),
                                );
                            }
                            if (res.discount_name === "won") {
                                setPaymentRoom((prev) =>
                                    prev.map((item) => ({
                                        ...item,
                                        couponDiscount: discountValue / paymentRoom.length,
                                    })),
                                );
                            }
                            toast({
                                duration: 3000,
                                position: "top",
                                title:
                                    res.discount_name === "percent"
                                        ? `${res.discount}% 할인 적용`
                                        : `${res.discount}원 할인 적용`,
                                status: "success",
                            });
                            setCouponApply(true);
                        }
                    },
                },
            );
        }
    };

    const handleCouponCancel = () => {
        setCouponApply(false);
        setPaymentRoom((prev) =>
            prev.map((item) => ({
                ...item,
                couponDiscount: 0,
            })),
        );
        toast({
            duration: 3000,
            position: "top",
            title: "쿠폰 적용 취소",
            status: "warning",
        });
    };
    useEffect(() => {
        if (payMethod !== "account") setValue("bank", "");
    }, [payMethod]);

    return (
        <Flex flex="1" flexDir="column" rowGap="24px" borderRadius="16px" boxSizing="border-box">
            <>
                <CustomTitle>예약정보입력</CustomTitle>
                <Flex flexDir="column">
                    <CustomInputTitle>예약자정보</CustomInputTitle>
                    <Box>
                        <FormElement
                            widthSize="full"
                            control={control}
                            type="text"
                            placeholder="예약자 성함"
                            name="buyer"
                            id="buyer"
                            label="예약자명"
                            value=""
                            isRequired={true}
                        />
                        <FormElement
                            widthSize="full"
                            control={control}
                            type="tel"
                            placeholder="ex)010-0000-0000"
                            name="phoneNumber"
                            id="phoneNumber"
                            label="연락처"
                            value=""
                            isRequired={true}
                        />
                        <FormElement
                            widthSize="full"
                            control={control}
                            type="text"
                            placeholder="예약 시 요청사항"
                            name="memo"
                            id="memo"
                            label="예약시 요청사항"
                            value=""
                            isRequired={false}
                        />
                    </Box>
                </Flex>
                <Flex flexDir="column" gap="8px">
                    <Text>쿠폰</Text>
                    <Flex gap="8px" alignItems="center">
                        <Input
                            ref={inputRef}
                            type="text"
                            name="input_coupon"
                            id="input_coupon"
                            defaultValue=""
                            placeholder="쿠폰입력"
                            disabled={couponApply}
                        />
                        <Button disabled={couponApply} type="button" w="120px" onClick={handleCouponCheck}>
                            적용
                        </Button>
                        {couponApply && (
                            <Button disabled={!couponApply} type="button" w="120px" onClick={handleCouponCancel}>
                                취소
                            </Button>
                        )}
                    </Flex>
                </Flex>
                <Flex flexDir="column" gap="8px">
                    <CustomInputTitle>결제수단</CustomInputTitle>
                    <RadioBox control={control} name="payMethod" option={updatedPaymentModes} />
                </Flex>
                {use === "true" && payMethod === "account" && (
                    <Flex flexDir="column" gap="8px">
                        <CustomInputTitle>입금 계좌선택</CustomInputTitle>
                        <Controller
                            control={control}
                            name="bank"
                            defaultValue=""
                            render={({ field }) => (
                                <Select {...field} placeholder="입금계좌선택">
                                    {account.map((it: { [key: string]: any }, index: number) => (
                                        <option value={it.bank} key={index}>
                                            {it.bank}
                                        </option>
                                    ))}
                                </Select>
                            )}
                        />
                    </Flex>
                )}
            </>
        </Flex>
    );
};
